import { VideoSourceEnum } from 'api';
import { CreativeTemplatesEntities } from '../../../../../constants';
import { useCreativeTemplatesBuilderStore } from 'stores/CreativeTemplatesBuilderStore';

export const useVideoTabs = () => {
  const store = useCreativeTemplatesBuilderStore();

  const handleChangeActiveVideoTab = (tab: VideoSourceEnum) => store.setActiveVideoTab(tab);

  const selections = store.imageOrVideoCreativeTemplateInputs[CreativeTemplatesEntities.VIDEOS];

  const selectedVideos = {
    accountVideos: selections.filter(({ videoSource }) => videoSource === VideoSourceEnum.ACCOUNT).length,
    pageVideos: selections.filter(({ videoSource }) => videoSource === VideoSourceEnum.PAGE).length,
    manualVideos: selections.filter(({ videoSource }) => videoSource === VideoSourceEnum.MANUAL).length
  };

  return {
    selectedVideos,
    handleChangeActiveVideoTab,
    activeVideoTab: store.activeVideoTab
  };
};
